<div class="ra-filters">
    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-people-filter-organization">Organization</label>
        <agu-select Id="ra-people-filter-organization" AriaLabel="Organization" [Options]="OrganizationSelect" [Value]="OrganizationValue" (ValueChange)="OnOrganizationChange($event)" />
    </div>
    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-people-filter-location">Location</label>
        <agu-select Id="ra-people-filter-location" AriaLabel="Location" [Options]="LocationSelect" [Value]="LocationValue" (ValueChange)="OnLocationChange($event)" />
    </div>
    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-people-filter-area">Research area</label>
        <agu-select Id="ra-people-filter-area" AriaLabel="Research area" [Options]="ResearchAreaSelect" [Value]="ResearchAreaValue" (ValueChange)="OnResearchAreaChange($event)" />
    </div>
    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-people-filter-show-label">Show</span>
        <div class="ra-filters__switches" role="group" aria-labelledby="ra-people-filter-show-label">
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Saved only" OffLabel="Saved only" [ngModel]="ShowSavedOnly" (ngModelChange)="ShowSavedOnlyChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Has mutual co-authors" OffLabel="Has mutual co-authors" [ngModel]="HasMutualCoauthors" (ngModelChange)="OnHasMutualCoauthorsChange($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Suggested only" OffLabel="Suggested only" [ngModel]="RecommendedOnly" (ngModelChange)="RecommendedOnlyChange.emit($event)" />
            </div>
        </div>
    </div>
</div>
